import React from 'react';
import type { User, BusinessUser } from '../../../../types/usersDemo';
import { HeadingSmall, LabelMedium, LabelSmall } from 'baseui/typography';
import { toaster } from 'baseui/toast';
import { getStatusColor } from '../../utils/helpers';
import { mockInvitations } from '../../../../data/mock/usersDemo';

interface ProfileTabProps {
  contact: User | BusinessUser;
  onOpenId?: () => void;
}

export const ProfileTab: React.FC<ProfileTabProps> = ({ contact, onOpenId }) => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <HeadingSmall style={{ margin: '0', color: '#666' }}>Contact & Identification</HeadingSmall>
        <div 
          role="button"
          tabIndex={0}
          aria-label="Open ID document"
          style={{ cursor: 'pointer', padding: '4px', marginLeft: '8px', transition: 'opacity 0.2s ease' }}
          onClick={(e) => { e.stopPropagation(); onOpenId?.(); }}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpenId?.(); } }}
          title="Open ID"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: '#666' }}>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14,2 14,8 20,8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10,9 9,9 8,9"/>
          </svg>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
        <div>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Email</div>
          <div
            role="button"
            tabIndex={0}
            aria-label="Copy email to clipboard"
            style={{ fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}
            title="Click to copy"
            onClick={() => {
              navigator.clipboard?.writeText((contact as User).email || '');
              toaster.positive('Email copied to clipboard', { autoHideDuration: 1500 });
            }}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigator.clipboard?.writeText((contact as User).email || ''); toaster.positive('Email copied to clipboard', { autoHideDuration: 1500 }); } }}
          >
            {(contact as User).email}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Phone</div>
          <div
            role={(contact as User).phone ? 'button' : undefined}
            tabIndex={(contact as User).phone ? 0 : -1}
            aria-label={(contact as User).phone ? 'Copy phone to clipboard' : undefined}
            style={{ fontSize: '14px', fontWeight: '500', cursor: (contact as User).phone ? 'pointer' : 'default' }}
            title={(contact as User).phone ? 'Click to copy' : undefined}
            onClick={() => {
              const p = (contact as User).phone || '';
              if (p) {
                navigator.clipboard?.writeText(p);
                toaster.positive('Phone copied to clipboard', { autoHideDuration: 1500 });
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                const p = (contact as User).phone || '';
                if (p) {
                  e.preventDefault();
                  navigator.clipboard?.writeText(p);
                  toaster.positive('Phone copied to clipboard', { autoHideDuration: 1500 });
                }
              }
            }}
          >
            {(contact as User).phone || 'Not provided'}
          </div>
        </div>
      </div>

      {/* Recent Activity removed per request */}
    </div>
  );
};

export default ProfileTab;


